/*
 * @Descripttion:
 * @version:
 * @Author: qiangXiong
 * @Date: 2021-08-11 20:11:00
 * @LastEditors: qiangXiong
 * @LastEditTime: 2021-08-13 14:51:38
 */
(function () {
  function a() {
    var b = document.documentElement.clientWidth;
    b = b > 1920 ? 1920 : b;
    var c = (b / 1920) * 100;
    c = c > 40 ? 40 : c;
    document.getElementsByTagName("html")[0].style.fontSize = c + "px";
  }
  a();
  window.onresize = a;
})();
